import React, { useCallback, useEffect, useState } from 'react';
import { HomefieldIconSignCancel } from '@dsg-tech/homefield-react-icons';
import { getFeatureFlagByNameSelector } from 'store/selectors';
import { Popover } from '@dsg-tech/homefield-react';
import { useAppSelector } from 'store/store';
import './MenuPopover.scss';

type MountComponent = 'allCategories' | 'hamburgerMenu';

export interface MenuPopoverProps {
  hamburgerMenuRef: React.RefObject<null>;
  component: MountComponent;
}

export const useMenuPopover = () => {
  const [showMenuPopover, setShowMenuPopover] = useState(false);
  const showMenuPopoverFlag = useAppSelector(getFeatureFlagByNameSelector('showMenuPopover'));
  const [newTaxoPopoverClosed, setNewTaxoPopoverClosed] = useState<string | null>(null);

  const taxoPopOverHasBeenClosed = useCallback(() => {
    if (showMenuPopoverFlag) {
      // If we don't type check window object hydration issues appear
      if (typeof window !== 'undefined') {
        localStorage.setItem('NewTaxoPopoverClosed', 'true');
      }
      setShowMenuPopover(false);
      setNewTaxoPopoverClosed('true');
    }
  }, [showMenuPopoverFlag]);

  useEffect(() => {
    // Access localStorage only on the client side
    const storedValue = localStorage.getItem('NewTaxoPopoverClosed');
    setNewTaxoPopoverClosed(storedValue);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMenuPopover(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShowMenuPopover(false);
    taxoPopOverHasBeenClosed();
  };
  return {
    showMenuPopover,
    handleClose,
    showMenuPopoverFlag,
    newTaxoPopoverClosed,
    taxoPopOverHasBeenClosed,
  };
};

const MenuPopover = ({ hamburgerMenuRef, component }: MenuPopoverProps) => {
  const { showMenuPopover, handleClose } = useMenuPopover();
  const styles = {
    allCategories: { top: '15px' },
    hamburgerMenu: { left: '21px', top: '8px' },
  };

  return (
    <Popover
      className="new-taxo-menu-dialog hmf-display-none hmf-display-lg-none"
      open={showMenuPopover}
      anchorElement={hamburgerMenuRef.current}
      style={styles[component]}>
      <div className="new-taxo-menu-dialog-content hmf-p-s">
        <div className="hmf-display-flex hmf-flex-row hmf-align-items-center hmf-justify-content-around hmf-mb-xxxs">
          <span className="hmf-header-bold-s hmf-mr-l">Explore Our New Menu!</span>
          <HomefieldIconSignCancel
            height={24}
            width={24}
            onClick={() => handleClose()}
            className="hmf-ml-xxxs"
            aria-label="Close popover"
          />
        </div>
        <span className="hmf-body-l">
          All categories and services are now in the menu. Let&apos;s get you game-ready!
        </span>
      </div>
    </Popover>
  );
};

export default MenuPopover;
